import React from 'react';
import { FiAlertCircle, FiCheck, FiRefreshCw } from 'react-icons/fi';

const PaymentSelectionModal = ({
  show,
  pendingPaymentData,
  selectedPendingOrderId,
  setSelectedPendingOrderId,
  confirmingPayment,
  onConfirm,
  onClose
}) => {
  if (!show || !pendingPaymentData) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl max-w-lg w-full max-h-[90vh] overflow-hidden shadow-2xl">
        {/* Header */}
        <div className="p-4 bg-yellow-50 border-b border-yellow-200">
          <div className="flex items-center gap-2 text-yellow-700">
            <FiAlertCircle size={24} />
            <h3 className="font-bold text-lg">Chọn đơn hàng để thanh toán</h3>
          </div>
          <p className="text-sm text-yellow-600 mt-1">
            Có {pendingPaymentData.orders?.length || 0} đơn hàng cùng số tiền
          </p>
        </div>
        
        {/* Transaction Info */}
        <div className="p-4 bg-blue-50 border-b">
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div>
              <span className="text-gray-500">Số tiền nhận:</span>
              <span className="font-bold text-blue-600 ml-2">
                {pendingPaymentData.amount?.toLocaleString()}đ
              </span>
            </div>
            <div>
              <span className="text-gray-500">Nội dung:</span>
              <span className="font-medium ml-2">{pendingPaymentData.content || '(Trống)'}</span>
            </div>
          </div>
        </div>
        
        {/* Orders List */}
        <div className="overflow-y-auto max-h-[50vh]">
          {pendingPaymentData.orders?.map((order) => (
            <div
              key={order._id}
              onClick={() => setSelectedPendingOrderId(order._id)}
              className={`p-4 border-b cursor-pointer transition-colors ${
                selectedPendingOrderId === order._id
                  ? 'bg-green-50 border-l-4 border-l-green-500'
                  : 'hover:bg-gray-50'
              }`}
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-800">
                      {order.tableName || (order.tableNumber ? `Bàn ${order.tableNumber}` : 'Mang đi')}
                    </span>
                    {order.orderCode && (
                      <span className="text-xs bg-gray-200 px-2 py-0.5 rounded">
                        {order.orderCode}
                      </span>
                    )}
                  </div>
                  <div className="text-sm text-gray-500 mt-1">
                    <span>{order.customerName}</span>
                    <span className="mx-2">•</span>
                    <span>{order.itemsCount} món</span>
                    <span className="mx-2">•</span>
                    <span>
                      {new Date(order.createdAt).toLocaleTimeString('vi-VN', { 
                        hour: '2-digit', 
                        minute: '2-digit' 
                      })}
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-bold text-green-600">
                    {order.totalAmount?.toLocaleString()}đ
                  </div>
                  <div className={`text-xs px-2 py-0.5 rounded ${
                    order.status === 'completed' ? 'bg-blue-100 text-blue-700' :
                    order.status === 'preparing' ? 'bg-yellow-100 text-yellow-700' :
                    'bg-gray-100 text-gray-700'
                  }`}>
                    {order.status === 'completed' ? 'Hoàn thành' :
                     order.status === 'preparing' ? 'Đang làm' : 'Chờ xác nhận'}
                  </div>
                </div>
              </div>
              {selectedPendingOrderId === order._id && (
                <div className="mt-2 flex items-center text-green-600 text-sm">
                  <FiCheck className="mr-1" />
                  <span>Đã chọn đơn này</span>
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* Footer Buttons */}
        <div className="p-4 bg-gray-50 border-t flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-100"
          >
            Bỏ qua
          </button>
          <button
            onClick={onConfirm}
            disabled={!selectedPendingOrderId || confirmingPayment}
            className="flex-1 py-2.5 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {confirmingPayment ? (
              <>
                <FiRefreshCw className="animate-spin" />
                <span>Đang xử lý...</span>
              </>
            ) : (
              <>
                <FiCheck />
                <span>Xác nhận thanh toán</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSelectionModal;
